export interface AdminUserInfo {
  id: string;
  tenantId: string;
  emailAddress: string;
  role: string;
}
